import React from 'react'
import vizzhyIcon from '../../Assests/Team/blackVizzhyIcon.svg';
import '../../Styles/RoleOfDashboard.scss'
function RoleofDashboard() {
    return (
        <>
            {/* <div className='w-100 mt-5'>
                <div className='how-it-works-text p-5 mx-5 fs-3 overall-text-color '>Role of Dashboards</div>


                <div >
                    <div className='w-100 text-center role-dashboard '>
                        <img className='role-dashboard-img ' src={TeamRole1} alt="Snow" />
                    </div>
                    <div className='w-100 text-center role-dashboard mt-3'>
                        <img className=' role-dashboard-img' src={TeamRole2} alt="Snow" />
                    </div>
                </div>


            </div> */}


            <div className='text-center role-dashboard the-futureHeight'>
                <div>
                    <img className='role-dashboard-img ' src={vizzhyIcon} alt="Snow" />
                </div>
                <div className='mt-4 pt-4 overall-text-color the-futureText' >
                    <div >
                        The Future of Health is Here,

                    </div>
                    <div>
                        and you are Part of It.
                    </div>
                </div>
                <div
                    className="mt-4 px-5 sub-futureOf-health text-center"
                  
                >
                   
                        With Vizzhy’s app, you are contributing to a new standard in health and wellness. By tracking and sharing your health data, you help drive valuable insights for personalized care and a healthier future for all.
                  
                </div>

            </div>
        </>

    )
}

export default RoleofDashboard
